var exports = {
  "zr": "FreeProOffer.module__root___cDh3QX",
  "Kk": "FreeProOffer.module__icon___cDh3QX",
  "C": "FreeProOffer.module__copy___cDh3QX",
  "DD": "FreeProOffer.module__title___cDh3QX",
  "VA": "FreeProOffer.module__subtitle___cDh3QX",
  "x6": "FreeProOffer.module__button___cDh3QX",
};

module.exports = exports;
